<template>
  <div>
    <TopBarBack />
    <div class="gsma-page">
      <nuxt-img
        class="gsma-logo"
        width="200"
        src="/logos/gsma.svg"
      />
      <section class="section-1">
        <nuxt-img
          class="w-full"
          src="img/gsma/section-1.png"
        />
        <p>
          GSMA는 긍정적인 비즈니스 환경과 사회적 변화를 위한 혁신의 기초가 되는 모바일 생태계를
          통합하는 글로벌 조직입니다.
        </p>
      </section>

      <section class="section-2">
        <nuxt-img
          class="w-full"
          src="img/gsma/section-2.png"
        />
        <nuxt-img
          width="142"
          class="gadgetkorea-logo"
          src="/gadget-logo-kr.png"
        />
        <h2>
          가제트코리아 주식회사는<br />
          GSMA의 회원인 한국의 유일한<br />
          스타트업입니다.
        </h2>
        <p>
          가제트코리아 주식회사는 SIM 기반 데이터 로밍 플랫폼 'USIMSA'를 운영하며 2024년 8월
          8일GSMA(글로벌 모바일 통신 시스템 협회)의 정회원으로 공식 등록되었습니다.<br /><br />

          이 회원 자격을 통해 글로벌 통신 산업에서 더 중요한 역할을 할 수 있는 기회를 제공하며, 기술
          혁신과 국제 협력을 위한 기반을 강화합니다.<br /><br />

          GSMA는 전 세계에서 750개 이상의 모바일 운영자와 400개 이상의 관련 기업이 참여하는 세계
          최대의 모바일 산업 협회입니다. GSMA는 모바일 산업의 표준화, 기술 개발 및 정책 수립을
          주도합니다.
        </p>
      </section>

      <section class="section-3">
        <div class="image-container">
          <nuxt-img
            class="w-full"
            src="img/gsma/section-3.png"
          />
          <div class="text-area">
            <span>
              한국에서는 SK 텔레콤, KT, LG Uplus와 같은<br />
              주요 통신사가 이미 정회원이며,
            </span>
            <span>
              가제트코리아 주식회사는<br />
              가입한 첫 번째 스타트업입니다.
            </span>
          </div>
        </div>
        <p>
          가제트코리아 주식회사는 eSIM 기반 데이터 로밍 서비스를 제공할 뿐만 아니라 eSIM
          애플리케이션에 대한 전문성을 보유하고 있습니다.<br /><br />

          우리는 맞춤형 로밍 플랜을 제공하는 글로벌 서비스 플랫폼을 운영하고 있으며, B2B 및 M2M(머신
          투 머신) 기업 서비스를 통해 국내외 시장에서 계속 성장하고 있습니다. 이 GSMA 회원 자격을
          통해 가제트코리아 주식회사는 글로벌 통신 산업의 주요 파트너가 되는 것을 목표로 하고
          있습니다.
        </p>
      </section>

      <NuxtLink
        id="gsma_outlink_btn"
        to="https://www.gsma.com/get-involved/gsma-membership/gsma_orgs/gadget-korea-inc/#:~:text=Gadget%20Korea%20Inc.%20-%20Membership.%20Gadget%20Korea%20Inc.%20is%20a"
        target="_blank"
        class="link flex flex-align-center p-16"
      >
        <span>GSMA 공식 파트너, USIMSA 바로가기</span>
        <Icons
          path="outline/chevron-right"
          width="16"
          color="#0176F9"
        />
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})

useHead({
  title: 'GSMA',
  meta: [
    {
      hid: 'description',
      name: 'description'
    }
  ]
})
</script>

<style lang="scss" scoped>
.gsma-page {
  padding-top: calc(56px + 32px);
  padding-bottom: 100px;
  .gsma-logo {
    margin-left: 16px;
    margin-bottom: 24px;
  }
  section {
    p {
      padding: 0 16px;
      @include body5-regular;
      color: $gray-600;
    }
    &.section-1 {
      margin-bottom: 80px;
      p {
        margin-top: 24px;
      }
    }
    &.section-2 {
      .gadgetkorea-logo {
        margin: 48px 16px 16px;
      }
      h2 {
        padding: 0 16px;
        @include body1-semibold;
        color: $gray-700;
      }
      p {
        margin: 48px 0;
      }
    }
    &.section-3 {
      .image-container {
        position: relative;
      }
      .text-area {
        position: absolute;
        bottom: 32px;
        left: 16px;
        color: $base-white;
        span {
          display: block;
        }
        span:nth-child(1) {
          margin-bottom: 16px;
        }
        span:nth-child(2) {
          @include body1-semibold;
        }
      }
      p {
        margin: 48px 0;
      }
    }
  }
  .link {
    color: $brand-point;
    @include body7-semibold;
  }
}
</style>
